var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52729 5.5312C3.78764 5.27085 4.20975 5.27085 4.4701 5.5312L7.9987 9.0598L11.5273 5.5312C11.7876 5.27085 12.2098 5.27085 12.4701 5.5312C12.7305 5.79155 12.7305 6.21366 12.4701 6.47401L8.4701 10.474C8.20975 10.7344 7.78764 10.7344 7.52729 10.474L3.52729 6.47401C3.26694 6.21366 3.26694 5.79155 3.52729 5.5312Z",
    fill: "#101828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.0e4d6825330503cab02f916ef2de8f42.svg";
export { ForwardRef as ReactComponent };